module.exports = __webpack_public_path__ + "img/cv.cf8a5a79.svg";